import React, { useCallback, useEffect, useState, createContext, useContext } from 'react';
interface ThemeContextType {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
function getDefaultTheme(): 'light' | 'dark' {
  try {
    const stored = localStorage.getItem('edumarket_theme');
    if (stored === 'light') return 'light';
  } catch {}
  return 'dark';
}
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState<'light' | 'dark'>(getDefaultTheme);
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    try {
      localStorage.setItem('edumarket_theme', theme);
    } catch {}
  }, [theme]);
  const toggleTheme = useCallback(() => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  }, []);
  return <ThemeContext.Provider value={{
    theme,
    toggleTheme
  }} data-id="element-188">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}